"use strict";

exports.__esModule = true;
var _Card = _interopRequireDefault(require("./Card"));
exports.default = _Card.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}